/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./BaseIcon.vue?vue&type=template&id=bd3d97b2"
import script from "./BaseIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseIcon.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports